import _ from 'underscore';

import Collection from '../../collection';
import Config from '../../config';
import Module from '../../core/module';
import Task from '../../model/task';
import TaskFilter from '../../view/tasks.filter';
import TasksModule from './list';
import ScheduleFormModule from '../schedule/form';
import ScheduleTemplatesModule from '../schedule/templates.list';

import { TaskNew, newTask } from '../../view/task.new';
import { fetch } from '../../collection/comments';
import { ask, } from '../../utils/popups';
import { promisify, requestify, deferred, } from '../../utils/promisify';
import { del, } from '../../http/api';
import { delay, } from '../../utils/promisify';
import { hashify } from '../../utils/arrays';
import { beginLock, endLock } from '../../loader';
import { CircleBlue, PinRed, PinGray, TaskIcon, PinGreen, PinBlue } from '../../view/map.icons';





export default Module.extend( {

    initialize(options = {}) {
        Module.prototype.initialize.call( this, options );

        let form;
        const self = this;

        const actions = this.options.actions = {
            
            defaults: 'edit',
        
            multitask() {
                const { 
                    layers, datatables, clusters,
                    types, organizations, contracts,
                    statuses, priorities, fields, 
                    serviceObjectMappings,
                    locationService
                } = options;
                if (!form)
                    form = new TaskNew( { 
                        layers, datatables, clusters,
                        locationService,
                        types, organizations, contracts,
                        statuses, priorities,
                        fields,
                        serviceObjectMappings, 
                    } );

                promisify( newTask( form, priorities ) )
                    .then( ({ task }) => {
                        if (task.point || task.lon && task.lat)
                            return self.fetchAndUpdateLayers();
                    } );
            },
            
            edit(current) {
                self.trigger( TasksModule.OPEN_TASK, current );
            },
            
            destroy(current) {
                ask( 'issue::modal delete - confirmation text',
                    'issue::modal delete - title', 'actions::yes', 'actions::no',
                    () =>  requestify( $.ajax( {
                        url: Config.url( `/news/${current.id}` ),
                        dataType: 'json',
                        data: JSON.stringify( { action: 'delete' } ),
                        method: 'POST',
                        contentType: 'application/json; charset=UTF-8' } ) )
                    .then( resp => {
                        if (!+resp.res)
                            return Promise.reject( resp.resText ) } )
                    .then( () => {
                        beginLock( this );
                        return self.fetchAndUpdateLayers().then( () => endLock( this ) );
                    } ) )
            },
        };

        const issues = this.options.issues = new Collection( {
            endpoint: 'tasks/bbox?apiVersion=2.1&sortBy=id&sortDirection=DESC&maxClusters=25',
            responseAt: 'tasks',
            countAt: 'total',
            actions: actions,
            model: Task,
            parseResponse(modelsAttrs, { active_id, schedules }) {
                schedules = hashify( schedules, schedule => [schedule.id, schedule] );

                return modelsAttrs.map( ({ comments, task, capabilities, ...attrs }) => {
                    const taskAttrs = { 
                        id: task.id,
                        task,
                        schedule: schedules[task.schedule_id],
                        capabilities, 
                        ...attrs };

                    if (task.id != active_id)
                        taskAttrs.lastComment = comments[0];
                    else
                        taskAttrs.comments = comments;

                    return taskAttrs;
                } );
            },

            // override to avoid picking up the first row as active row
            restoreActive() {
                if (!this.activeId || this.activeRow() == undefined)
                    this.deactivate();
            },
        } );

        this.setState( {
            filters: TaskFilter.defaultFilters(),
        } );

        // this.commentsChannel = CommentsLive
        //     .filter( message => message instanceof Insert )
        //     .forEach( message => this.trigger( 'comments:income', message.model ) ); // model === attrs of Model
    },

    template: 'jst/module.tasks.map',

    url() {
        return 'map';
    },

    open() {
        const { filters, } = this.state();

        return this.render()
            .then( () => this.Filter.bind( new TaskFilter.Model( filters ) ) )
            .then( () => delay( 500 ) )
            .then( () => this.fetchAndUpdateLayers() )
            .then( () => {
                const current = this.options.issues.current();
                this.setState( { activeId: current ? current.id : undefined } );

                if (current)
                    return this.fetchCurrentComments(), this.Task.bind( current );
            } )
            .then( () => this );
    },

    start() {
        const { issues } = this.options;
        let lastFiltering = Promise.resolve();

        // issues.plugActionSource( this.Grid );

        // this.listenTo( this.Search, 'search', queryString => 
        //     lastFiltering = lastFiltering
        //         .then( () => {
        //             this.setState( { queryString, } );
        //             this.navigated();
        //             return issues.filter( getHttpFilters( this.state() ) );
        //         } )
        //         .catch( () => undefined ) );

        // if (issues.current())
        //     this.Comments.bind( issues.current() );

        this.Map
            .onMoveOrZoom( _.debounce( () => this.fetchAndUpdateLayers(), 500 ) );

        this.Map.listenTo( issues, 'activate deactivate', 
            () => {
                const current = issues.current();
                if (current)
                    this.Task.bind( current ), this.fetchCurrentComments();
                else
                    this.Task.unbind();

                const activeId = current ? current.id : undefined;
                if (this.state().activeId != activeId)
                    this.setState( { activeId, } ), this.navigated();
            } );

        // this.listenTo( this, 'comments:income',
        //     comment => handleIncomingComment.call( this, comment ) );

        this.Filter.focus();
    },

    stop() {
        const { issues } = this.options;

        this.stopListening( this.Filter );
        // this.stopListening( this, 'comments:income' );

        // this.Map.stopListening( issues );

        return this;
    },

    serialize() {
        const { issues, types, priorities, statuses, 
            contracts, organizations,
            locationService, } = this.options;

        return {
            queryString: this.state().queryString || '',
            actionList: issues.actions,
            collection: issues,
            types, 
            statuses,
            priorities,
            contracts, organizations,
            locationService,
        };
    },

    events: {

        'keyup [name=title]'(e) {
            if (13 == e.keyCode)
                this.Grid.trigger( 'action:default' ),
                e.preventDefault();
        },

    },

    [Module.event( 'Filter:filter' )](filters) {
        this.setState( { filters, page: 1, /*activeId: undefined,*/ } );
        this.navigated();
        this.fetchAndUpdateLayers();
    },

    [Module.event( 'nav:list' )]() {
        this.trigger( TasksModule.OPEN_LIST, this.state() );
    },

    [Module.event( 'nav:contracts' )]() {
        this.trigger( TasksModule.OPEN_CONTRACTS, this.state() );
    },

    [Module.event( ':schedule:edit' )]({ id }) {
        return this.trigger( ScheduleFormModule.POPUP_EDIT, 
            // pass id only to force Schedule.byId in Form
            id );
    },

    [Module.event( ':schedule:delete' )]({ id }) {
        ask( 'schedule::modal delete schedule - confirmation text', 
            'schedule::modal delete schedule - title', 
            'actions::yes', 
            'actions::no',
            () => del( `/timetables/${id}` )
                .blocking( this ).cerebellum()
                .execute() )
            .then( () => {
                this.options.issues.current().get( 'schedule' ).deleted = true;
                return this.Task.render();
            } );
    },

    [Module.event( ':schedule:templates' )]({ id }) {
        return this.trigger( ScheduleTemplatesModule.POPUP, 
            // pass id only to force Schedule.byId in Template List
            id );
    },

    // [Module.event( 'Comments:comments:recalc-unread' )]() {
    //     this.Grid.render();
    // },

    requestCount_: 0,

    fetchAndUpdateLayers() {
        const requestId = ++this.requestCount_;

        const bounds = this.Map.bounds();
        const bbox = [
            bounds._southWest.lng, bounds._southWest.lat, 
            bounds._northEast.lng, bounds._northEast.lat];

        const degDist = bounds._northEast.lat - bounds._southWest.lat;
        const minDegDist = degDist * 1.5 * 48 / this.Map.$el.height();
        const minKmDist = 20000 * minDegDist / 180;

        const httpFilters = {
            ...getHttpFilters( this.state() ),
            bbox,
            minD: minKmDist
        };

        return this.options.issues
            .filter( httpFilters, 1, this.state().activeId )
            .then( ([a, coll, { tasks, items }]) => {

                if (requestId != this.requestCount_)
                    return;

                const hash = hashify( 
                    coll.models.map( (task, index) => [task.id, index] ),
                    ([id, index]) => [id, index] );

                const clusters = items
                    .filter( cluster => cluster.count > 1 )
                    .map( ({ count, lon, lat }) => ({ title: count, location: { lon, lat } }) );

                const locations = tasks
                    .map( ({ task: { id, lon, lat }}) => ({ id, location: { lon, lat } }) );

                this.Map.updateLayer( 'clusters', 
                    this.Map.newClusterLayer( clusters, CircleBlue ) );
                this.Map.updateLayer( 'tasks', 
                    this.Map.newClusterLayer( locations, 
                        ({ id }) => {
                            const task = coll.at( hash[id] );
                            switch (task.get( 'stage' )) {
                                case 0: return PinGray();
                                case 1: return PinBlue();
                                case 2: return PinGreen();
                            }

                            return PinBlue();
                        },
                        (marker, attrs) => marker.on( 'click', 
                            (a, b) => {
                                this.options.issues.activate( hash[attrs.id] );
                                this.Map.updateLayer( 'activeTasks',
                                    this.Map.newClusterLayer( [attrs], PinRed ) );
                            } ) ) );
                this.Map.updateLayer( 'activeTasks',
                    this.Map.newClusterLayer( locations.filter( ({ id }) => id == this.state().activeId ),
                        PinRed ) );
            } );
    },

    fetchCurrentComments() {
        const current = this.options.issues.current();
        if (current && !current.comments_)
            return fetch( current.id ).then( ([json, coll]) =>
                current.trigger( 'comments:load', current.comments_ = json ) );
    }

}, {

} );

function getHttpFilters(tasksModuleState) {
    const { filters, activeId, } = tasksModuleState;
    const { assigned_status, category_id, news_type_id, confirmed,
        assigned_organization_id, assigned_user_id,
        contract_id, organization_id,
        title, } = filters;
    
    const result = {};
    if (+assigned_organization_id > 0) result.assignedOrganizationId = assigned_organization_id;
    if (+assigned_user_id > 0) result.assignedUserId = assigned_user_id;
    if (+organization_id > 0) result.organizationId = organization_id;
    if (+contract_id > 0) result.contractId = contract_id;
    if (assigned_status) result.onlyStatus = assigned_status;
    if (category_id) result.category_id = category_id;
    if (news_type_id) result.type_id = news_type_id;
    if (confirmed) result.confirmed = confirmed;
    if (title) result.search = title;
    if (activeId) result.id = activeId;
            
    return result;
}



// WEBPACK FOOTER //
// ./src/js/module/tasks/map.js